import api from './api';

const adminProductService = {
  // Get products awaiting marketing content
  getProductQueue: async () => {
    const response = await api.get('/products/admin/products/', {
      params: { is_marketing_complete: false }
    });
    return response.data;
  },

  // Get all products (with optional filters)
  getProducts: async (filters = {}) => {
    const response = await api.get('/products/admin/products/', {
      params: filters
    });
    return response.data;
  },

  // Get single product by ID for enrichment (uses admin endpoint to get all products including incomplete)
  getProductById: async (id) => {
    const response = await api.get(`/products/admin/products/${id}/enrich/`);
    return response.data;
  },

  // Enrich product with marketing content
  enrichProduct: async (id, enrichData) => {
    // Create FormData for multipart/form-data request (supports file uploads)
    const formData = new FormData();

    // Add text fields
    if (enrichData.title_en) formData.append('title_en', enrichData.title_en);
    if (enrichData.title_el) formData.append('title_el', enrichData.title_el);
    if (enrichData.description_en) formData.append('description_en', enrichData.description_en);
    if (enrichData.description_el) formData.append('description_el', enrichData.description_el);
    if (enrichData.category) formData.append('category', enrichData.category);

    // Add image files (up to 4 images) - backend expects main_image, image_2, image_3, image_4
    // Only send images if they are File objects (newly uploaded), not existing image URLs/objects
    if (enrichData.image1 instanceof File) formData.append('main_image', enrichData.image1);
    if (enrichData.image2 instanceof File) formData.append('image_2', enrichData.image2);
    if (enrichData.image3 instanceof File) formData.append('image_3', enrichData.image3);
    if (enrichData.image4 instanceof File) formData.append('image_4', enrichData.image4);

    // Add is_marketing_complete flag
    if (enrichData.is_marketing_complete !== undefined) {
      formData.append('is_marketing_complete', enrichData.is_marketing_complete);
    }

    const response = await api.patch(
      `/products/admin/products/${id}/enrich/`,
      formData,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      }
    );
    return response.data;
  },

  // Delete product
  deleteProduct: async (id) => {
    try {
      const response = await api.delete(`/products/admin/products/${id}/`);
      return response.data;
    } catch (error) {
      const errorMessage = error.response?.data?.error || error.response?.data?.detail || 'Failed to delete product';
      throw new Error(errorMessage);
    }
  },

  // Toggle product visibility
  toggleProductVisibility: async (id, isActive) => {
    try {
      const response = await api.patch(`/products/admin/products/${id}/`, {
        is_active: isActive
      });
      return response.data;
    } catch (error) {
      const errorMessage = error.response?.data?.error || error.response?.data?.detail || 'Failed to update product visibility';
      throw new Error(errorMessage);
    }
  },

  // Get product categories
  getCategories: async () => {
    const response = await api.get('/products/categories/');
    return response.data;
  }
};

export default adminProductService;
